import 'antd/lib/breadcrumb/style';

export * from 'antd/lib/breadcrumb';
export { default as Breadcrumb } from 'antd/lib/breadcrumb';
